import * as S from './styles';
import * as Separator from '@radix-ui/react-separator';

export type SeparatorProps = Separator.SeparatorProps &
  React.ComponentProps<typeof S.SeparatorRoot> & {
    color?: string;
  }

export function Divider ({ ...props }: SeparatorProps) {
  return (
    <S.SeparatorRoot {...props} color={props.color} />
  )
}

export default Divider;